import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import styled from "styled-components/native";
import { ProductCategory } from "@utils/constants";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import RenderHTML from "react-native-render-html";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { Diamond } from "@src/types/DiamondDetail";
import { Platform } from "react-native";

type PriceDisclaimerProps = {
  itemDetail?: Diamond;
  config: any;
  spacing?: SpaceType;
  productType?: ProductCategory;
  fromSharePage?: boolean;
  priceMode?: PriceModes;
};

const PriceDisclaimer = ({
  itemDetail,
  spacing,
  priceMode,
  config,
}: PriceDisclaimerProps) => {
  const { theme, t, typography } = useScreenOptionsHooks();
  if (
    (itemDetail !== undefined &&
      itemDetail?.price_disclaimer &&
      Object.keys(itemDetail?.price_disclaimer).length === 0) ||
    !config ||
    Object.keys(config).length === 0 ||
    !config?.price_modes?.includes(priceMode)
  ) {
    return null;
  }

  const disclaimerText = itemDetail?.price_disclaimer
    ? itemDetail?.price_disclaimer?.text
    : config?.description;

  const titleText = itemDetail?.price_disclaimer
    ? itemDetail?.price_disclaimer?.title
    : config?.label;

  if (!titleText && !disclaimerText) {
    return null;
  }

  return (
    <>
      {spacing && <Spacer size={spacing} />}
      <PriceDisclaimerContainer>
        <PriceDisclaimerHeader>
          {config?.icon && (
            <VDBIcon
              color={theme[config.icon.color as keyof typeof theme] as string}
              size={24}
              variant={IconsVariant.VDBCustom}
              name={config.icon.data}
            />
          )}
          {titleText && (
            <VDBText color={theme["core-05"]} type={typography["H3-M"]}>
              {t(titleText)}
            </VDBText>
          )}
        </PriceDisclaimerHeader>
        {disclaimerText && (
          <RenderHTML
            defaultTextProps={{ selectable: Platform.OS === "web" }}
            source={{ html: t(disclaimerText) }}
            tagsStyles={{
              body: { ...typography["Minor-R"], color: theme["core-05"] },
            }}
          />
        )}
      </PriceDisclaimerContainer>
    </>
  );
};

const PriceDisclaimerContainer = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: ${SpaceType.Basic}px;
  padding: ${SpaceType.Double}px;
  gap: ${SpaceType.Double}px;
`;

const PriceDisclaimerHeader = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${SpaceType.Basic}px;
`;

export default PriceDisclaimer;
